import { AbstractClient, CompositionClient } from "@/app/client";
import {
  EmailAccount,
  EmailAccountAdminList,
  EmailAccountCreate,
  EmailAccountList,
  EmailAccountUpdate,
  ForwardingInfo,
  ForwardingSetupResponse,
  PageOptions,
} from "@/app/types";

export default class APIEmailAccountsSub extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getEmailAccounts = async (
    pageOptions: PageOptions,
  ): Promise<EmailAccountList> => {
    let res = await this._fetch({
      url: "/email-accounts/",
      method: "GET",
      params: pageOptions,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getManagedEmailAccounts = async (
    pageOptions: PageOptions,
  ): Promise<EmailAccountAdminList> => {
    let res = await this._fetch({
      url: "/email-accounts/managed",
      method: "GET",
      params: pageOptions,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getEmailAccount = async (accountId: string): Promise<EmailAccount> => {
    let res = await this._fetch({
      url: `/email-accounts/${accountId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  createEmailAccount = async (
    account: EmailAccountCreate,
  ): Promise<EmailAccount> => {
    let res = await this._fetch({
      url: "/email-accounts/",
      method: "POST",
      body: account,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  updateEmailAccount = async (
    accountId: string,
    account: EmailAccountUpdate,
  ): Promise<EmailAccount> => {
    let res = await this._fetch({
      url: `/email-accounts/${accountId}`,
      method: "PUT",
      body: account,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteEmailAccount = async (accountId: string): Promise<void> => {
    await this._fetch({
      url: `/email-accounts/${accountId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };

  testConnection = async (
    accountId: string,
  ): Promise<{ status: string; message: string }> => {
    let res = await this._fetch({
      url: `/email-accounts/${accountId}/test-connection`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getForwardingInfo = async (): Promise<ForwardingInfo> => {
    let res = await this._fetch({
      url: "/email-accounts/forwarding-info",
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  setupForwarding = async (
    accountId: string,
    slug?: string,
  ): Promise<ForwardingSetupResponse> => {
    let res = await this._fetch({
      url: `/email-accounts/${accountId}/setup-forwarding`,
      method: "POST",
      body: { slug: slug ?? null },
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
